<template>
  <div class="newaddparticulars">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="planlobby_content">
        <div class="planlobby_content_info">
          <div class="leftbox">
            <div class="planlobby_content_item">
              <span class="spansty">车牌号码：</span>
              <div class="inpstyNew">
                {{ iteminfo.plate }}
              </div>
            </div>
            <div class="planlobby_content_item">
              <span class="spansty">车帮号：</span>
              <div class="inpstyNew">
                {{ iteminfo.carhelpno }}
              </div>
            </div>
            <!-- <div class="planlobby_content_item">
              <span class="spansty">车辆所有人：</span>
              <div class="inpstyNew">
                {{ iteminfo.carowner }}
              </div>
            </div>
            <div class="planlobby_content_item">
              <span class="spansty">司机姓名：</span>
              <div class="inpstyNew">
                {{ iteminfo.driverName }}
              </div>
            </div>
            <div class="planlobby_content_item">
              <span class="spansty">驾驶证号码：</span>
              <div class="inpstyNew">
                {{ iteminfo.driveingLicencecode }}
              </div>
            </div>
            <div class="planlobby_content_item">
              <span class="spansty">挂车证号码：</span>
              <div class="inpstyNew">
                {{ iteminfo.hangLicencecode }}
              </div>
            </div>
            <div class="planlobby_content_item">
              <span class="spansty">车主手机号码：</span>
              <div class="inpstyNew">
                {{ iteminfo.telephone }}
              </div>
            </div> -->
            <div class="planlobby_content_item">
              <span class="spansty">排放标准：</span>
              <div class="inpstyNew">
                {{ iteminfo.discharge }}
              </div>
            </div>
            <div class="planlobby_content_item">
              <span class="spansty">海关监管：</span>
              <div class="inpstyNew">
                {{ iteminfo.iscustoms==1?"监管":"非监管" }}
              </div>
            </div>
            <div class="planlobby_content_item">
              <span class="spansty">道路运输证有效期：</span>
              <div class="inpstyNew">
                {{ iteminfo.cardTime }}
              </div>
            </div>
            
          </div>
          <div class="rightbox">
            <!-- <div class="planlobby_content_item">
              <span class="spansty">挂车号码：</span>
              <div class="inpstyNew">
                {{ iteminfo.hangPlate }}
              </div>
            </div>
            <div class="planlobby_content_item">
              <span class="spansty">司机身份证：</span>
              <div class="inpstyNew">
                {{ iteminfo.driverCreticard }}
              </div>
            </div> -->
            <div class="planlobby_content_item">
              <span class="spansty">车辆识别代号：</span>
              <div class="inpstyNew">
                {{ iteminfo.carLicencecode }}
              </div>
            </div>
            <div class="planlobby_content_item">
              <span class="spansty">车辆类型：</span>
              <div class="inpstyNew">
                {{ iteminfo.cartype==='1'?'新能源车':iteminfo.cartype==='2'?'燃油车':'天然气车' }}
              </div>
            </div>
            <div class="planlobby_content_item">
              <span class="spansty">年检有效期：</span>
              <div class="inpstyNew">
                {{ iteminfo.endDate }}
              </div>
            </div>
            <!-- <div class="planlobby_content_item">
              <span class="spansty">车辆类型：</span>
              <div class="inpstyNew">
                {{ iteminfo.truckType }}
              </div>
            </div>
            <div class="planlobby_content_item">
              <span class="spansty">应急联系电话：</span>
              <div class="inpstyNew">
                {{ iteminfo.emytelephone }}
              </div>
            </div> -->
            <div class="planlobby_content_item">
              <span class="spansty">限定载重：</span>
              <div class="inpstyNew">
                {{ iteminfo.truckTypecode }}
              </div>
            </div>
            <div class="planlobby_content_item">
              <span class="spansty">备注：</span>
              <div class="inpstyNew">
                {{ iteminfo.mark }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cardinfo">
        <div class="planlobby_content_bot">
          <!-- 身份证正面 -->
          <!-- <div class="content">
            <span class="photo_titile">身份证正面</span>
            <el-image
              v-if="photo.frontOfIdcard"
              style="width: 100%; height: 100%"
              lazy
              :src="photo.frontOfIdcard"
              :preview-src-list="[photo.frontOfIdcard]"
            >
            </el-image>
          </div> -->
          <!-- 驾驶证正面 -->
          <!-- <div class="content">
            <span class="photo_titile">驾驶证正面</span>
            <el-image
              v-if="photo.frontDriverLicense"
              style="width: 100%; height: 100%"
              lazy
              :src="photo.frontDriverLicense"
              :preview-src-list="[photo.frontDriverLicense]"
            >
            </el-image>
          </div> -->
          <!-- 行驶证正面 -->
          <div class="content">
            <span class="photo_titile">行驶证正面</span>
            <el-image
              v-if="photo.frontDrivingLicense"
              style="width: 100%; height: 100%"
              lazy
              :src="photo.frontDrivingLicense"
              :preview-src-list="[photo.frontDrivingLicense]"
            >
            </el-image>
          </div>
          <!-- 挂车证正面 -->
          <!-- <div class="content">
            <span class="photo_titile">挂车证正面</span>
            <el-image
              v-if="photo.frontTrailerPermit"
              style="width: 100%; height: 100%"
              lazy
              :src="photo.frontTrailerPermit"
              :preview-src-list="[photo.frontTrailerPermit]"
            >
            </el-image>
          </div> -->
          <!-- 排放证明 -->
          <!-- <div class="content">
            <span class="photo_titile">排放证明</span>
            <el-image
              v-if="photo.emissionCertificate"
              style="width: 100%; height: 100%"
              lazy
              :src="photo.emissionCertificate"
              :preview-src-list="[photo.emissionCertificate]"
            >
            </el-image>
          </div> -->
          <!-- 行驶证副页正面 -->
          <div class="content">
            <span class="photo_titile">行驶证副页正面</span>
            <el-image
              v-if="photo.backDrivingLicense"
              style="width: 100%; height: 100%"
              lazy
              :src="photo.backDrivingLicense"
              :preview-src-list="[photo.backDrivingLicense]"
            >
            </el-image>
          </div>
          <!-- 行驶证副页反面 -->
          <div class="content">
            <span class="photo_titile">行驶证副页反面</span>
            <el-image
              v-if="photo.backDrivingLicenseBack"
              style="width: 100%; height: 100%"
              lazy
              :src="photo.backDrivingLicenseBack"
              :preview-src-list="[photo.backDrivingLicenseBack]"
            >
            </el-image>
          </div>
          <div class="content">
            <span class="photo_titile">道路运输证图片</span>
            <el-image
              v-if="iteminfo.cardNo"
              style="width: 100%; height: 100%"
              lazy
              :src="iteminfo.cardNo"
              :preview-src-list="[iteminfo.cardNo]"
            >
            </el-image>
          </div>
        </div>
        <div class="button">
          <div class="center">
            <button
              class="btn"
              style="color: #838aa9; background: #f3f4f5"
              @click="jumpPage"
            >
              返回
            </button>
            <button
              class="btn"
              style="background: #ff4900; color: #ffffff"
              @click="isshow = true"
            >
              不通过
            </button>
            <button class="btn" @click="throughTheReview">通过</button>
          </div>
        </div>
      </div>

      <pdialog
        :isshowdialog="isshow"
        :imgposition="'bot'"
        v-model="iteminfo.cause"
        width="50%"
        @closedialog="nopass"
      ></pdialog>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import mSelect from "@/components/mSelect";
import mSuperIpt from "@/components/mSuperIpt";
import pdialog from "@/components/pdialog.vue";
export default {
  name:'newaddparticulars',
  data() {
    return {
      listitem: [
        { name: "会员管理" },
        { name: "新增审核", path: "/member/newaddmember" },
        { name: "详情" },
      ],
      selectoptions: [],
      selectletouroptions: [],
      selectletcartypeop: [],
      selectastrict: [],
      iteminfo: {},
      photo: {},
      isshow: false,
      timeout: null,
    };
  },
  created() {
    this.getList();
    this.getItemInfo(window.sessionStorage.getItem("infoid"));
  },
  components: {
    mTitle,
    mSelect,
    mSuperIpt,
    pdialog,
  },
  methods: {
    async getList() {
      const { data: data0 } = await this.$http("api1", "/sys/dic/list", "get", {
        dictionaryType: "与车主关系",
      });
      if (!data0.data) return;
      this.selectoptions = [];
      data0.data.forEach((item) => {
        this.selectoptions.push(item.val);
      });

      const { data: data1 } = await this.$http("api1", "/sys/dic/list", "get", {
        dictionaryType: "排放标准",
      });
      if (!data1.data) return;
      this.selectletouroptions = [];
      data1.data.forEach((item) => {
        this.selectletouroptions.push(item.val);
      });

      const { data: data2 } = await this.$http("api1", "/sys/dic/list", "get", {
        dictionaryType: "车辆类型",
      });
      if (!data2.data) return;
      this.selectletcartypeop = [];
      data2.data.forEach((item) => {
        this.selectletcartypeop.push(item.val);
      });

      const { data: data3 } = await this.$http("api1", "/sys/dic/list", "get", {
        dictionaryType: "限重载重",
      });
      if (!data3.data) return;
      this.selectastrict = [];
      data3.data.forEach((item) => {
        this.selectastrict.push(item.val);
      });
    },
    async getItemInfo(id) {
      if (!id) return;
      const { data } = await this.$http(
        "api1",
        `/driver/car/info/${id}`,
        "get"
      );
      if (!data.car) return;
      this.iteminfo = data.car;
      this.photo = data.carCertificate[0] || {};
    },
    throughTheReview() {
      this.$messageBox
        .confirm(`是否通过审核?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          const { data } = await this.$http(
            "api1",
            // "/driver/car/update",
            "/driver/car/carAuditPass", //21年5月9日 新接口
            "post",
            // {
            //   useStatus: 5, //待发卡
            //   // useStatus: 3,//改成停用
            //   id: this.iteminfo.id,
            // }
            {
              ids: [this.iteminfo.id], //测试用
            }
          );
          if (!data || !data.msg == "success")
            return this.$message.error("失败");
          window.sessionStorage.removeItem("infoid");
          this.$message.success("审核成功");
          this.jumpPage();
        })
        .catch((err) => err);
    },
    async nopass(val) {
      if (val == "affirm") {
        const { data } = await this.$http(
          "api1",
          "/driver/car/update",
          "post",
          {
            useStatus: 2,
            id: this.iteminfo.id,
            cause: this.iteminfo.cause,
          }
        );
        if (!data || data.msg != "success") return this.$message.error("失败");
        this.$message.success("操作成功");
        this.jumpPage();
      } else {
        this.isshow = false;
      }
    },
    jumpPage() {
      this.$router.push("/member/newaddmember");
    },
  },
};
</script>
<style lang="scss" scoped>
.newaddparticulars {
  position: relative;
  height: 100%;
  .componentSty_content {
    position: absolute;
    top: 50px;
    bottom: 0;
    width: 100%;
    background: #fff;
  }
  .planlobby_content {
    position: relative;
    height: 60%;
    width: 100%;
    border-radius: 2px;
    .planlobby_content_info {
      position: absolute;
      z-index: 999;
      width: 70%;
      left: 50%;
      top: 2%;
      bottom: 0;
      transform: translateX(-50%);
      .leftbox,
      .rightbox {
        float: left;
        height: 100%;
        width: 50%;
      }
      .planlobby_content_item {
        height: 10%;
        // font-size: 80%;
        line-height: 40px;
        .spansty {
          float: left;
          // font-size: 80%;
          box-sizing: border-box;
          width: 35%;
          height: 60%;
          text-align: right;
        }
        .spansty::before,
        .inpstyNew::before {
          content: "";
          display: inline-block;
          height: 100%;
          vertical-align: middle;
        }
        .inpsty,
        .inpstyNew {
          box-sizing: border-box;
          float: right;
          border: none;
          outline: none;
          // font-size: 80%;
          width: 65%;
          height: 60%;
          border-radius: 2px;
          background: #f3f4f5;
          white-space: nowrap;
        }
        .inpstyNew {
          background: transparent;
        }
      }
    }
  }
  .cardinfo {
    position: relative;
    height: 35%;
    .planlobby_content_bot {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      width: 90%;
      height: 80%;
      display: flex;
      justify-content: center;
      .content {
        position: relative;
        float: left;
        height: 100%;
        width: 20%;
        margin-left: 1%;
        border-radius: 2px;
        // font-size: 12px;
        background: #f3f4f5;
        .photo_titile {
          position: absolute;
          top: -30px;
          left: 50%;
          transform: translateX(-50%);
          color: #868687;
          // font-size: 80%;
        }
        img {
          width: 100%;
        }
      }
    }
    .button {
      position: absolute;
      top: 80%;
      bottom: 0;
      width: 100%;
      .center {
        position: absolute;
        left: 50%;
        top: 50%;
        height: 70%;
        width: 20%;
        transform: translate(-50%, -50%);
        .btn {
          border: none;
          font-size: 70%;
          border-radius: 2px;
          height: 100%;
          width: 30%;
          margin-left: 3.3%;
          color: #fff;
          background: #17B6A1;
          cursor: pointer;
        }
        .btn:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .imgcontent {
    width: 100%;
    height: 600px;
    text-align: center;
    .img {
      width: auto;
      max-width: 100%;
      height: 100%;
    }
  }
}
</style>